import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Stack,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import {
  DividerLine,
  SubmitButton,
  Heading,
  InformationText,
  InputField,
  SuggestionText,
  Title,
} from "./submitWork.components";
import { useCookies } from "react-cookie";
import { submitInternshipWork } from "../../../services/enroll";
import Confirmation from "../confirmationDialog/confirmation";

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <Heading {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 35,
            top: 20,
            color: "#000",
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </Heading>
  );
};

function SubmitWorkDialog({ internshipID, uploadWork, setUploadWork }) {
  const [cookies] = useCookies();
  const [workUrl, setWorkUrl] = useState("");
  const [invalidUrl, setInvalidUrl] = useState(false);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setUploadWork(false);
  };

  const handleUrlSubmit = async () => {
    const urlRegex = new RegExp(
      "((http|https)://)(www.)?" +
      "[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]" +
      "{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)"
    );

    if (urlRegex.test(workUrl)) {
      setInvalidUrl(false);
      console.log(workUrl);
      const workData = {
        userID: cookies.userID,
        internshipID: internshipID,
        workUrl: workUrl,
        verified: 0,
      };
      await submitInternshipWork(cookies, workData)
        .then((response) => {
          if (response.status === 200) {
            handleClose();
            setWorkUrl("");
            setOpen(true)
          }
        })
        .catch((error) => console.log(error));
    } else {
      setInvalidUrl(true);
    }
  };

  return (
    <div>
      <Confirmation open={open} />
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={uploadWork}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Upload Assignment
        </BootstrapDialogTitle>
        <DividerLine />
        <DialogContent sx={{ width: { md: 525 }, px: "35px" }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Title>Upload your Work</Title>
            <Typography
              sx={{
                fontSize: "12px",
                color: "red",
                display: invalidUrl ? "block" : "none",
              }}
            >
              invalid URL format
            </Typography>
          </Stack>
          <InputField
            fullWidth
            type="url"
            sx={{ height: 49 }}
            value={workUrl}
            onChange={(e) => setWorkUrl(e.target.value)}
          />
          <SuggestionText>*Note : Paste url only</SuggestionText>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2.5}
          >
            <InformationText>
              Your certificate will be mailed to you on successful completion of
              this internship
            </InformationText>
            <SubmitButton onClick={handleUrlSubmit}>Submit</SubmitButton>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default SubmitWorkDialog;
